import axios from "axios";
import { getToken } from "../../Shared/baseURL";

const DEFAULT_QUERY_PARAMS = {
  filters: JSON.stringify({}),
  pageable: JSON.stringify({ page: 0, size: 50, sort: ["createdAt,DESC"] }),
  sort: JSON.stringify({ sort: ["createdAt,DESC"] }),
};

const ACTIVE_SUBSCRIPTION_STATUSES = ["ACTIVE", "TRIALING", "PAST_DUE"];

const normalizeSubscriptionStatus = (value) =>
  String(value || "")
    .trim()
    .toUpperCase();

const normalizeSubscriptionsPayload = (payload) => {
  if (Array.isArray(payload?.subscriptions)) {
    return payload.subscriptions;
  }

  if (Array.isArray(payload?.content)) {
    return payload.content;
  }

  if (Array.isArray(payload)) {
    return payload;
  }

  return [];
};

export const getActiveSubscription = async () => {
  const token = await getToken();
  const res = await axios.get("/pss/subscriptions", {
    headers: { Authorization: token },
    params: DEFAULT_QUERY_PARAMS,
  });

  const data = res.data || {};

  const allSubs = normalizeSubscriptionsPayload(data);

  const activeSubs = allSubs.filter(
    (sub) =>
      sub &&
      typeof sub.status === "string" &&
      ACTIVE_SUBSCRIPTION_STATUSES.includes(
        normalizeSubscriptionStatus(sub.status),
      ),
  );

  return {
    subscriptions: allSubs,
    active: activeSubs[0] || null,
    rawResponse: data,
  };
};

export const cancelSubscription = async (subscriptionID, reason = "") => {
  const token = await getToken();
  return await axios
    .put(`/pss/subscriptions/${subscriptionID}/cancel`, {
      ...(reason ? { reason } : {}),
    }, {
      headers: {
        Authorization: token,
      },
    })
    .then((res) => res.data);
};

export const cancelCancellation = async (subscriptionID) => {
  const token = await getToken();
  return await axios
    .put(
      `/pss/subscriptions/${subscriptionID}/resume`,
      {},
      {
        headers: {
          Authorization: token,
        },
      },
    )
    .then((res) => res.data);
};

export const verifySubscriptionCancellation = async (subscriptionId) => {
  const data = await getActiveSubscription();
  const subscriptions = Array.isArray(data?.subscriptions) ? data.subscriptions : [];
  const matchingSubscription = subscriptions.find(
    (subscription) => String(subscription?.id) === String(subscriptionId),
  );

  if (!matchingSubscription) {
    return { success: true, status: "NOT_FOUND" };
  }

  const normalizedStatus = normalizeSubscriptionStatus(
    matchingSubscription?.status,
  );
  return {
    success: ["CANCELED", "CANCELLED", "INACTIVE"].includes(normalizedStatus),
    status: normalizedStatus,
  };
};

export const getBillingPortalSession = async () => {
  const token = await getToken();
  const { data } = await axios.get("/pss/subscriptions/billing-portal-session", {
    headers: {
      Authorization: token,
    },
  });

  return data;
};
